/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 16oTSa7DQBPEWCKQEY9DXA
// Component: 7sfyMDRM7TU7

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 16oTSa7DQBPEWCKQEY9DXA/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 16oTSa7DQBPEWCKQEY9DXA/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicZpusob.module.css"; // plasmic-import: 7sfyMDRM7TU7/css

import Icon2Icon from "./icons/PlasmicIcon__Icon2"; // plasmic-import: 5QCLbTMH8s6r/icon

createPlasmicElementProxy;

export type PlasmicZpusob__VariantMembers = {};
export type PlasmicZpusob__VariantsArgs = {};
type VariantPropType = keyof PlasmicZpusob__VariantsArgs;
export const PlasmicZpusob__VariantProps = new Array<VariantPropType>();

export type PlasmicZpusob__ArgsType = {
  children?: React.ReactNode;
  slot?: React.ReactNode;
  slot2?: React.ReactNode;
};
type ArgPropType = keyof PlasmicZpusob__ArgsType;
export const PlasmicZpusob__ArgProps = new Array<ArgPropType>(
  "children",
  "slot",
  "slot2"
);

export type PlasmicZpusob__OverridesType = {
  root?: Flex__<"div">;
  h1?: Flex__<"h1">;
};

export interface DefaultZpusobProps {
  children?: React.ReactNode;
  slot?: React.ReactNode;
  slot2?: React.ReactNode;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicZpusob__RenderFunc(props: {
  variants: PlasmicZpusob__VariantsArgs;
  args: PlasmicZpusob__ArgsType;
  overrides: PlasmicZpusob__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_16oTSa7DQBPEWCKQEY9DXA",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div className={classNames("all", sty.freeBox__pzM7U)}>
        {renderPlasmicSlot({
          defaultContents: (
            <Icon2Icon
              className={classNames("all", sty.svg__l1Adt)}
              role={"img"}
            />
          ),

          value: args.children
        })}
      </div>
      <div className={classNames("all", sty.freeBox__p1N0F)}>
        <h1
          data-plasmic-name={"h1"}
          data-plasmic-override={overrides.h1}
          className={classNames("all", "h1", "h1__16oTS", sty.h1)}
        >
          {renderPlasmicSlot({
            defaultContents: "Po\u0161lete \u017e\u00e1dost",
            value: args.slot,
            className: classNames(sty.slotTargetSlot)
          })}
        </h1>
        <div className={classNames("all", sty.freeBox__jsFjg)}>
          {renderPlasmicSlot({
            defaultContents:
              "Vypl\u0148te online formul\u00e1\u0159 na na\u0161em webu \u2014 je to jednoduch\u00e9 a rychl\u00e9",
            value: args.slot2,
            className: classNames(sty.slotTargetSlot2)
          })}
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "h1"],
  h1: ["h1"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  h1: "h1";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicZpusob__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicZpusob__VariantsArgs;
    args?: PlasmicZpusob__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicZpusob__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicZpusob__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicZpusob__ArgProps,
          internalVariantPropNames: PlasmicZpusob__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicZpusob__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicZpusob";
  } else {
    func.displayName = `PlasmicZpusob.${nodeName}`;
  }
  return func;
}

export const PlasmicZpusob = Object.assign(
  // Top-level PlasmicZpusob renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    h1: makeNodeComponent("h1"),

    // Metadata about props expected for PlasmicZpusob
    internalVariantProps: PlasmicZpusob__VariantProps,
    internalArgProps: PlasmicZpusob__ArgProps
  }
);

export default PlasmicZpusob;
/* prettier-ignore-end */
